export default "__VITE_ASSET__Bafp8vH9__"